import { OfflineDataFetcher } from '@skinsoft/data-store/src/offline/offline-data-fetcher';

import { AuditCampaign, auditCampaignSelectors, ThesaurusTermDataStore, thesaurusTermSelectors } from '@skinsoft/entity/'
import { getTranslatedString } from '@skinsoft/ui';
import { matchesRegex } from '@skinsoft/utils';
import { of } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';

export class AuditCampaignOfflineDataFetcher extends OfflineDataFetcher<AuditCampaign>{
    constructor(cacheKey: string) {
        super(cacheKey);
    }

    protected async queryTextFilter(entity: AuditCampaign, queryText: string, locale: string): Promise<boolean> {
        const lowerCaseQueryText: string = queryText.toLowerCase()

        // campaign title
        const title: string = auditCampaignSelectors.title(entity, locale);
        const titleMatch = title ? matchesRegex(lowerCaseQueryText, title) : false;

        // campaign number
        const refNumber: string = auditCampaignSelectors.identificationNumber(entity);
        const refNumberMatch = refNumber ? matchesRegex(lowerCaseQueryText, refNumber) : false;

        // campaign number
        const campaignTypeId: string = auditCampaignSelectors.auditType(entity);
        const campaignType: string = await ThesaurusTermDataStore.getInstance().fetchOne(campaignTypeId)
            .pipe(
                take(1),
                switchMap(
                    term => {
                        return of(getTranslatedString(thesaurusTermSelectors.preferredTerm(term), locale))
                    }
                )
            ).toPromise()
        const campaignTypeMatch = campaignType ? matchesRegex(lowerCaseQueryText, campaignType) : false;

        return titleMatch || refNumberMatch || campaignTypeMatch;
    }


}